<template>
<email-modal :open="show_email" @clicked="show_email = false" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-7 col-sm-12 fullviewport bg-blue-pattern">
        <div class="mt-5 front-wrapper">
          <h3 class="text-just-about-white logo-text">thomas<span class="text-light-blue">.gg</span></h3>
          <div class="header-section">
            <h3 class="text-light-blue subheading-text">Hello!</h3>
            <h1 class="text-just-about-white heading-text">I'm Thomas.</h1>
          </div>
        </div>
        <div class="text-center mt-5">
          <h5 class="text-light-blue quick-link-title">Quick Links</h5>
          <div class="text-just-about-white">
            <a href="https://github.com/period" class="quick-link">
              <font-awesome-icon :icon="['fab', 'github']" />
            </a>
            <a class="quick-link">
              <font-awesome-icon icon="envelope" @click="show_email = true" />
            </a>
            <a href="https://pics.thomas.gg" class="quick-link">
              <font-awesome-icon icon="camera" />
            </a>
            <a href="https://twitter.com/picsthomasgg" class="quick-link">
              <font-awesome-icon :icon="['fab', 'twitter']" />
            </a>
          </div>
        </div>
      </div>
      <div class="col-xl-5 col-sm-12 fullviewport-min bg-header-photo">
        <div class="align-bottom-about">
          <h2 class="text-dark-blue">A bit about me</h2>
          <p>I am a full stack developer, working on both web and non-web based projects. My initial love for development started from around the early age of seven working in Visual Basic. By age twelve, I was already taking on freelance work for PHP and Java projects. Nowadays, you will either find me at an airport perimeter photographing planes, or working primarily on Vue projects and PHP/NodeJS backends.</p>
        </div>
        <div class="align-bottom-interests">
          <h2 class="text-dark-blue">I'm interested in</h2>
          <ul class="list-unstyled row">
            <li class="list-item col-6">👨🏻‍💻 Software/web development</li>
            <li class="list-item col-6">✈ Aviation/Flight simulation</li>
            <li class="list-item col-6">🖨 3D printing</li>
            <li class="list-item col-6">📸 Photography</li>
            <li class="list-item col-6">🕵🏻‍♂️ Reverse engineering</li>
            <li class="list-item col-6">🤖 Automation</li>
            <li class="list-item col-6">🎄 Christmas light programming</li>
            <li class="list-item col-6">🖥 System Administration</li>
          </ul>
        </div>
      </div>
    </div>
    <previous-projects />
    <NameMCSkinart />
    <div class="row text-center">
      <p>&copy; thomas.gg 2021 - contact information can be found at the top; feel free to say hi!</p>
    </div>
  </div>
</template>

<script>
import PreviousProjects from "../components/PreviousProjects.vue";
import NameMCSkinart from "../components/NameMCSkinart.vue";
import EmailModal from "../components/EmailModal.vue";
export default {
  name: 'Home',
  components: {
    PreviousProjects,
    NameMCSkinart,
    EmailModal
  },
  data() {
    return {
      show_email: false
    }
  }
}
</script>
<style>
.align-bottom-about {
  margin-top: 67vh;
}
.align-bottom-interests {
  margin-top: 1vh;
}
.front-wrapper {
  margin-left: 25px;
}
.header-section {
  margin-top: 14vh;
  margin-bottom: 5%;
}
.bg-header-photo {
  background-image: url("https://i.thomas.gg/153de768-1de2-459a-ba12-5916b5acb1d0.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: 0% 95%;
  background-size: cover;
}
.fullviewport-min {
  min-height: 100vh;
}
@media screen and (min-width: 993px) {
  .fullviewport-min {
    height: 100vh;
  }
  .logo-text {
    font-size: 2.75vw;
  }
  .heading-text {
    font-size: 9vw;
  }
  .subheading-text {
    font-size: 5vw;
  }
  .quick-link-title {
    font-size: 3vw;
  }
  .quick-link {
    font-size: 2.75vw;
  }
}
@media screen and (max-width: 992px) {
  .logo-text {
    font-size: 7vw;
  }
  .heading-text {
    font-size: 20vw;
  }
  .subheading-text {
    font-size: 6.5vw;
  }
  .quick-link {
    font-size: 6.5vw;
  }
  .bg-header-photo {
    background-position: 85% 0%;
  }
  .align-bottom-about {
    margin-top: 2.5vh;
    margin-bottom: 40vh;
  }
}

a {
  color: inherit;
  text-decoration: inherit;
  cursor: pointer;
}
.quick-link {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
body, html {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
}
.fullviewport {
  height: 100vh;
}
.threequarterviewport {
  height: 75vh;
}
.bg-blue-pattern {
  /* background by SVGBackgrounds.com */
  background-color: #3587a4;
  background-attachment: fixed;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1116' height='930' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E");
}
.text-just-about-white {
  color: #C1DFF0;
}
.text-light-blue {
  color: #88CCF1;
}
.text-dark-blue {
  color: #307993;
}
</style>